// ============================================
// Profile Store (Zustand)
// ============================================

import { createStore } from 'zustand/vanilla';

export const useProfileStore = createStore((set, get) => ({
  // State
  profileSelectorOptions: {},

  // Actions
  setProfileSelectorOptions: (options) => set({ profileSelectorOptions: options }),

  // Reset
  reset: () => set({ profileSelectorOptions: {} })
}));

export default useProfileStore;
